export default "__VITE_ASSET__uRd4KuTP__"